export default __webpack_public_path__ + "locales/it/InviteDialog.json?hash=7c8a09c45723f74db0bec278a19c6c85";